import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

// Verbatim from battbox, applications/ui/src/config/locales/de.ts, as the customer's interim text.
// What may be changed here, and what deliberately may not, is in
// .github/plans/20260918-123059-landing-page.md.
const INTRO =
  "Wir freuen uns über Ihren Besuch auf unserer Webseite. Nachfolgend möchten wir Sie über den Umgang mit Ihren Daten gem. Art. 13 Datenschutzgrundverordnung (DSGVO) informieren.";

const SECTIONS = [
  {
    heading: "Datensicherheit",
    body: "Um Ihre Daten vor unerwünschten Zugriffen möglichst umfassend zu schützen, treffen wir technische und organisatorische Maßnahmen. Wir setzen auf unseren Webseiten ein Verschlüsselungsverfahren ein. Ihre Angaben werden von Ihrem Rechner zu unserem Server und umgekehrt über das Internet mittels einer TLS-Verschlüsselung übertragen. Sie erkennen dies in der Regel daran, dass in der Statusleiste Ihres Browsers das Schloss-Symbol geschlossen ist und die Adresszeile mit https:// beginnt.",
  },
  {
    heading: "Speicherung der IP-Adresse",
    body: "Darüber hinaus speichern wir keine IP-Adressen.",
  },
  {
    heading: "Speicherdauer",
    body: "Sofern wir nicht im Einzelnen bereits über die Speicherdauer informiert haben, löschen wir personenbezogene Daten, wenn sie für die vorgenannten Verarbeitungszwecke nicht mehr erforderlich sind und keine gesetzlichen Aufbewahrungspflichten einer Löschung entgegenstehen.",
  },
  {
    heading: "Ihre Rechte als betroffene Person",
    body: "Bei der Verarbeitung Ihrer personenbezogenen Daten gewährt die DSGVO Ihnen als betroffene Person bestimmte Rechte:",
  },
  {
    heading: "Auskunftsrecht (Art. 15 DSGVO)",
    body: "Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob Sie betreffende personenbezogene Daten verarbeitet werden; ist dies der Fall, so haben Sie ein Recht auf Auskunft über diese personenbezogenen Daten und auf die in Art. 15 DSGVO im Einzelnen aufgeführten Informationen.",
  },
  {
    heading: "Recht auf Berichtigung (Art. 16 DSGVO)",
    body: "Sie haben das Recht, unverzüglich die Berichtigung Sie betreffender unrichtiger personenbezogener Daten und ggf. die Vervollständigung unvollständiger Daten zu verlangen.",
  },
  {
    heading: "Recht auf Löschung (Art. 17 DSGVO)",
    body: "Sie haben das Recht, zu verlangen, dass Sie betreffende personenbezogene Daten unverzüglich gelöscht werden, sofern einer der in Art. 17 DSGVO im Einzelnen aufgeführten Gründe zutrifft.",
  },
  {
    heading: "Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO)",
    body: "Sie haben das Recht, die Einschränkung der Verarbeitung zu verlangen, wenn eine der in Art. 18 DSGVO aufgeführten Voraussetzungen gegeben ist, z. B. wenn Sie Widerspruch gegen die Verarbeitung eingelegt haben, für die Dauer der Prüfung durch den Verantwortlichen.",
  },
  {
    heading: "Recht auf Datenübertragbarkeit (Art. 20 DSGVO)",
    body: "In bestimmten Fällen, die in Art. 20 DSGVO im Einzelnen aufgeführt sind, haben Sie das Recht, die Sie betreffenden personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten bzw. die Übermittlung dieser Daten an einen Dritten zu verlangen.",
  },
  {
    heading: "Widerrufsrecht (Art. 7 DSGVO)",
    body: "Sofern die Verarbeitung von Daten auf Grundlage Ihrer Einwilligung erfolgt, sind Sie nach Art. 7 Abs. 3 DSGVO berechtigt, die Einwilligung in die Verwendung Ihrer personenbezogenen Daten jederzeit zu widerrufen. Bitte beachten Sie, dass der Widerruf erst für die Zukunft wirkt. Verarbeitungen, die vor dem Widerruf erfolgt sind, sind davon nicht betroffen.",
  },
  {
    heading: "Widerspruchsrecht (Art. 21 DSGVO)",
    body: "Werden Daten auf Grundlage von Art. 6 Abs. 1 S. 1 lit. f DSGVO (Datenverarbeitung zur Wahrung berechtigter Interessen) oder auf Grundlage von Art. 6 Abs. 1 S. 1 lit. e DSGVO (Datenverarbeitung zur Wahrung öffentlichen Interesse oder in Ausübung öffentlicher Gewalt) erhoben, steht Ihnen das Recht zu, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung Widerspruch einzulegen. Wir verarbeiten die personenbezogenen Daten dann nicht mehr, es sei denn, es liegen nachweisbar zwingende schutzwürdige Gründe für die Verarbeitung vor, die gegenüber Ihren Interessen, Rechten und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen.",
  },
  {
    heading: "Beschwerderecht bei einer Aufsichtsbehörde (Art. 77 DSGVO)",
    body: "Sie haben gem. Art. 77 DSGVO das Recht auf Beschwerde bei einer Aufsichtsbehörde, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden Daten gegen datenschutzrechtliche Bestimmungen verstößt. Das Beschwerderecht kann insbesondere bei einer Aufsichtsbehörde in dem Mitgliedstaat Ihres gewöhnlichen Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes geltend gemacht werden.",
  },
  {
    heading: "Geltendmachung Ihrer Rechte",
    body: "Sofern vorstehend nichts anderes beschrieben wurde, wenden Sie sich zur Geltendmachung Ihrer Betroffenenrechte bitte an die im Impressum genannte Stelle.",
  },
];

export const DatenschutzPage = () => (
  <Stack spacing={3}>
    <Typography variant="h1">Datenschutzerklärung</Typography>
    <Typography variant="body1">{INTRO}</Typography>

    {SECTIONS.map((section) => (
      <Stack key={section.heading} spacing={1}>
        <Typography variant="h5" component="h2">
          {section.heading}
        </Typography>
        <Typography variant="body1">{section.body}</Typography>
      </Stack>
    ))}
  </Stack>
);
